import PropTypes from 'prop-types';
import moment from 'moment';

// HoC
import { withStyles } from '@material-ui/core/styles';

// Utilities
import clsx from 'clsx';

// MuiComponents
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import ErrorIcon from '@material-ui/icons/Error';

const styles = ({ palette }) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
  },
  fullScreenRoot: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100vw',
    height: '100vh',
    flexDirection: 'column',
    background: 'rgba(55, 55, 55, 0.6)',
  },
  message: {
    padding: 15,
    maxWidth: 560,
    textAlign: 'center',
  },
  link: {
    color: palette.cncUI.misc.link,
    textDecoration: 'none',
  },
  icon: {
    color: palette.error.main,
  },
});

const PayrollDownAlert = props => {
  const {
    message,
    messageProps = {},
    iconProps = {},
    className,
    classes,
    fullScreen = false,
  } = props;
  // Pull the className out to combine with our className
  const { className: messageClassName } = messageProps;
  let updatedMessageProps = { ...messageProps };
  delete updatedMessageProps.className;

  // Pull the className out to combine with our className
  const { className: iconClassName } = iconProps;
  let updatedIconProps = { ...iconProps };
  delete updatedIconProps.className;

  const rootClass = clsx(
    {
      [classes.root]: !fullScreen,
      [classes.fullScreenRoot]: fullScreen,
    },
    className,
  );

  const dateCheck = moment()
    .utc()
    .isBefore(moment('2020-01-02T12:00:00.000Z'));

  const alertMessage = dateCheck ? (
    <Typography
      className={clsx(classes.message, messageClassName)}
      variant={'caption'}
      id="PayrollDownAlertMessage"
      {...updatedMessageProps}
    >
      We're sorry, but MyCast&Crew's Profile service will be unavailable from
      Sunday, December 29, 2019 at 6 pm PST until Thursday, January 2, 2020.
    </Typography>
  ) : (
    <Typography
      className={clsx(classes.message, messageClassName)}
      variant={'caption'}
      id="PayrollDownAlertMessage"
      {...updatedMessageProps}
    >
      Our apologies, but the system is currently unavailable. Please wait one
      hour before trying again. For immediate assistance, please contact our
      Employee Help Desk at{' '}
      <Link className={classes.link} href="tel:8188607756">
        (818) 860-7756
      </Link>{' '}
      or{' '}
      <Link
        className={classes.link}
        href="mailto:employeehelpdesk@castandcrew.com"
      >
        employeehelpdesk@castandcrew.com
      </Link>
      , or for Media Services assistance:{' '}
      <Link className={classes.link} href="tel:3102541702">
        (310) 254-1702
      </Link>{' '}
      or{' '}
      <Link
        className={classes.link}
        href="mailto:crewportalhelp@mediaservices.com"
      >
        crewportalhelp@mediaservices.com.
      </Link>
    </Typography>
  );

  return (
    <div className={rootClass} id="PayrollDownAlert">
      <ErrorIcon className={clsx(classes.icon, iconClassName)} {...iconProps} />
      {message && (
        <Typography
          className={clsx(classes.message, messageClassName)}
          variant={'caption'}
          id="PayrollDownAlertMessage"
          {...updatedMessageProps}
        >
          {message}
        </Typography>
      )}
      {!message && alertMessage}
    </div>
  );
};

PayrollDownAlert.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.string,
  messageProps: PropTypes.object,
  className: PropTypes.string,
};

export default withStyles(styles)(PayrollDownAlert);
